<div class="edit-product-modal-container" *ngIf="productData">
  <div class="edit-product-modal-title">
    {{ "pool_parameters.EDIT_PRODUCT.0" | translate }}
    {{ PrincipalProductName }} {{ productData.productDescription }}
  </div>

  <div class="edit-product-modal-description">
    {{
      "pool_parameters.EDIT_PRODUCT.1"
        | translate : { currency: currencySymbol }
    }}
  </div>

  <div class="edit-product-modal-content">
    <div class="options-container">
      <div
        class="option option-price"
        (click)="selectOption(EditOption.MARGIN)"
      >
        <div
          class="option-checkbox"
          [ngClass]="{
            'option-checkbox-selected': OptionSelected == EditOption.MARGIN
          }"
        >
          <div
            *ngIf="OptionSelected == EditOption.MARGIN"
            class="black-point"
          ></div>
        </div>
        <p>{{ "pool_parameters.EDIT_PRODUCT.2" | translate }}</p>
      </div>

      <div
        class="option option-margin"
        (click)="selectOption(EditOption.PRICE)"
      >
        <div
          class="option-checkbox"
          [ngClass]="{
            'option-checkbox-selected': OptionSelected == EditOption.PRICE
          }"
        >
          <div
            *ngIf="OptionSelected == EditOption.PRICE"
            class="black-point"
          ></div>
        </div>
        <p>
          {{
            "pool_parameters.EDIT_PRODUCT.3"
              | translate : { currency: currencySymbol }
          }}
        </p>
      </div>
    </div>

    <form class="input-container" [formGroup]="ProductDataForm">
      <div
        class="input-group-container"
        *ngIf="OptionSelected == EditOption.MARGIN"
      >
        <label>{{ "pool_parameters.EDIT_PRODUCT.4" | translate }}</label>
        <div class="input-div">
          <input type="number" formControlName="poolProfitMargin" />
          <div class="edit-unit">%</div>
        </div>
      </div>

      <div
        class="input-group-container"
        *ngIf="OptionSelected == EditOption.PRICE"
      >
        <label>
          {{
            "pool_parameters.EDIT_PRODUCT.5"
              | translate : { currency: currencySymbol }
          }}
        </label>
        <div class="input-div">
          <input type="number" formControlName="poolPrice" />
          <div class="edit-unit">{{ currencySymbol }}</div>
        </div>
      </div>
    </form>
  </div>

  <div class="edit-product-modal-footer">
    <div class="button-white button-padding-10" (click)="closeModal()">
      {{ "pool_parameters.EDIT_PRODUCT.6" | translate }}
    </div>
    <div
      class="button-green button-padding-10"
      (click)="saveParameters()"
      [ngClass]="{
        'button-opacity':
          !isFormModified || ProductDataForm.invalid || SaveLoading
      }"
    >
      {{ "pool_parameters.EDIT_PRODUCT.7" | translate }}
    </div>
    <img
      class="loading-spinner"
      *ngIf="SaveLoading"
      src="../../../../../assets/loading-spinner.gif"
      alt=""
    />
  </div>
</div>
